

interface growthBookConfigState {
    error: any | null;
    hasError: boolean;
    isInit: boolean;
}


export interface providersState {
    growthbook: growthBookConfigState;
}

const growthbookConfigState: growthBookConfigState = {
    error: null,
    hasError : false,
    isInit: false
}

export const initialProvidersState: providersState = {
    growthbook: growthbookConfigState
};